import React from 'react';
import { MapPin, Navigation } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { content } from '../mock';
import { OSMMap } from './OSMMap';

export const LocationSection = () => {
  const { language } = useLanguage();
  const t = content[language];

  return (
    <div className="pb-8 border-b">
      <h2 className="text-2xl font-semibold mb-4 text-gray-900 flex items-center gap-2">
        <MapPin className="h-6 w-6" />
        {t.locationTitle}
      </h2>
      
      <p className="text-gray-700 leading-relaxed mb-6">
        {t.locationDescription}
      </p>
      
      <div className="space-y-3 mb-6">
        {t.locationDetails.map((detail, index) => (
          <div key={index} className="flex items-start gap-3">
            <Navigation className="h-4 w-4 text-blue-600 flex-shrink-0 mt-1" />
            <span className="text-gray-700">{detail}</span>
          </div>
        ))}
      </div>

      <div className="mb-4">
        <OSMMap
          address={t.propertyLocation}
          markerLabel={t.propertyName}
          heightClassName="h-96"
        />
      </div>
    </div>
  );
};
